import { render, staticRenderFns } from "./AppInfoDialog.vue?vue&type=template&id=31ef0de4&scoped=true"
import script from "./AppInfoDialog.vue?vue&type=script&lang=js"
export * from "./AppInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./AppInfoDialog.vue?vue&type=style&index=0&id=31ef0de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef0de4",
  null
  
)

export default component.exports